"use strict";

exports.__esModule = true;
var _ClassificationSelector = require("./ClassificationSelector");
Object.keys(_ClassificationSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationSelector[key]) return;
  exports[key] = _ClassificationSelector[key];
});
var _ClassificationSelectorMenu = require("./ClassificationSelectorMenu");
Object.keys(_ClassificationSelectorMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationSelectorMenu[key]) return;
  exports[key] = _ClassificationSelectorMenu[key];
});